<template>
    <div v-loading="$parentInfo.dialog_CreateClass_Semester.loading">
        <el-form :model="$parentInfo.dialog_CreateClass_Semester.classForm" label-width="70px">
            <el-form-item label="课程学科">
                <el-input v-model="$parentInfo.modalData.subject.name" disabled></el-input>
            </el-form-item>

            <el-form-item label="任课老师">
                <el-input v-model="$parentInfo.modalData.teacher.name" disabled></el-input>
            </el-form-item>

            <el-form-item label="上课时间">
                <el-input :value="$parentInfo.modalData.timeData.content[0]+$parentInfo.modalData.timeData.content[1]" disabled></el-input>
            </el-form-item>

            <el-form-item label="开始时间">
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.start_time" placeholder="请输入" :disabled="!$parentInfo.powers.includes(175)"></el-input>
            </el-form-item>

            <el-form-item label="时长">
                <el-select v-model="$parentInfo.dialog_CreateClass_Semester.classForm.duration"
                           filterable remote clearable
                           placeholder="请选择时长"
                           @change="change_duration">
                    <el-option
                            v-for="item in durations"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item label="备注">
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.note" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="教室">
                <el-select v-model="$parentInfo.dialog_CreateClass_Semester.classForm.classroom_id"
                           filterable remote clearable :remote-method="handleSearchClassroom"
                           placeholder="请选择教室"
                           :loading="$parentInfo.dialog_CreateClass_Semester.search_loading">
                    <el-option
                            v-for="item in $parentInfo.classrooms"
                            :key="item.id"
                            :label="item.complete_name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="年级">
                <el-radio-group v-model="$parentInfo.dialog_CreateClass_Semester.classForm.grade_id" size="mini"
                                @change="get_course">
                    <el-radio-button border v-for="item in $parentInfo.grades" :label="item.id" :key="item.id">
                        {{item.name}}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="班级类型">
                <el-radio-group v-model="$parentInfo.dialog_CreateClass_Semester.classForm.class_type_id" size="mini"
                                :disabled="!$parentInfo.dialog_CreateClass_Semester.classForm.name"
                                @change="classTypeChange($parentInfo.dialog_CreateClass_Semester.classForm.class_type_id,'class_type')">
                    <template v-if="$parentInfo.modalData.subject.id!==24">
                        <el-radio-button :label="1">一对一</el-radio-button>
                        <el-radio-button :label="4">一对二</el-radio-button>
                        <el-radio-button :label="2">一对三</el-radio-button>
                        <el-radio-button :label="6">一对六</el-radio-button>
                        <el-radio-button :label="3">小班</el-radio-button>
                    </template>
                    <el-radio-button v-else :label="5">晚托</el-radio-button>

                </el-radio-group>
            </el-form-item>

            <el-form-item label="班型">
                <el-radio-group v-model="$parentInfo.dialog_CreateClass_Semester.classForm.type" size="mini" @change="typeChange()">
                    <el-radio-button :label="1">普通</el-radio-button>
                    <el-radio-button :label="2">衔接</el-radio-button>
                    <el-radio-button :label="3">Ti</el-radio-button>
                    <el-radio-button :label="7">全日制</el-radio-button>
                    <el-radio-button :label="4">试听</el-radio-button>
                    <el-radio-button :label="5" disabled>综评辅导</el-radio-button>
                    <el-radio-button :label="6" v-if="$parentInfo.filter.section_id==4">网络</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="冲刺课">
                <el-checkbox v-model="$parentInfo.dialog_CreateClass_Semester.classForm.sprintClass" :disabled="$parentInfo.filter.section_id!=4"></el-checkbox>
            </el-form-item>
            <el-form-item label="开始日期" style="height: 30px">
                <el-date-picker
                        v-model="$parentInfo.dialog_CreateClass_Semester.classForm.start_date"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="课程名称">
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.name"></el-input>
            </el-form-item>

            <el-form-item label="课次">
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.period"></el-input>
            </el-form-item>

            <el-form-item label="单价" v-if="$parentInfo.filter.section_id!==4 || !$parentInfo.dialog_CreateClass_Semester.classForm.sprintClass">
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price" :disabled="!$parentInfo.powers.includes(183)"></el-input>
            </el-form-item>
            <el-form-item label="单价(课时)" v-else>
                <el-input v-model="$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour" disabled></el-input>
            </el-form-item>

            <el-form-item>
                <el-button size="small" @click="storeClass"
                           :loading="$parentInfo.dialog_CreateClass_Semester.button_loading">提交
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateClass_Semester",
        data() {
            return {
                durations:[{
                    id:1.5,
                    name:'1.5小时'
                },{
                    id:1,
                    name:'1小时'
                },{
                    id:0.75,
                    name:'45分钟'
                },{
                    id:0.5,
                    name:'30分钟'
                }]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.dialog_CreateClass_Semester.classForm = {
                name: '',
                type: 1,
                classroom_id: '',
                note: '',
                subject_id: 0,
                teacher_id: 0,
                template_time_id: 0,
                template_time_semester_id: 0,
                semester_id: 0,
                class_type_id: 0,
                grade_id: 0,
                period: 0,
                unit_period_price: 0,
                start_date: '',
                nightClass: false,
                duration:1.5,
                unit_classHour:1,
                sprintClass:false
            };
            this.$parentInfo.dialog_CreateClass_Semester.classForm.subject_id =this.$parentInfo.modalData.subject.id;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.teacher_id = this.$parentInfo.modalData.teacher.teacher_id;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.semester_id = this.$parentInfo.modalData.semester.id;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.template_time_id = this.$parentInfo.modalData.timeData.id;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.template_time_semester_id = this.$parentInfo.modalData.timeData.template_time_semester_id;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.duration=this.$parentInfo.modalData.timeData.duration;
            this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour=this.$parentInfo.modalData.timeData.duration;
            this.$set(this.$parentInfo.dialog_CreateClass_Semester.classForm,'start_time',this.$parentInfo.modalData.timeData.start_time)
            if(this.$parentInfo.filter.section_id==4){
                this.$parentInfo.dialog_CreateClass_Semester.classForm.sprintClass=true;
            }
            if(this.$parentInfo.dialog_CreateClass_Semester.classForm.duration==0.75){
                this.$parentInfo.dialog_CreateClass_Semester.classForm.type=7;
            }
        },
        mounted() {
        },
        methods: {
            storeClass() {
                this.$parentInfo.dialog_CreateClass_Semester.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_class', {
                    'name': this.$parentInfo.dialog_CreateClass_Semester.classForm.name,
                    'type': this.$parentInfo.dialog_CreateClass_Semester.classForm.type,
                    'classroom_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.classroom_id,
                    'note': this.$parentInfo.dialog_CreateClass_Semester.classForm.note,
                    'subject_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.subject_id,
                    'teacher_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.teacher_id,
                    'template_time_semester_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.template_time_semester_id,
                    'semester_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.semester_id,
                    'class_type_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.class_type_id,
                    'grade_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.grade_id,
                    'period': this.$parentInfo.dialog_CreateClass_Semester.classForm.period,
                    'unit_period_price': this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price,
                    'start_date': this.$parentInfo.dialog_CreateClass_Semester.classForm.start_date,
                    'nightClass': this.$parentInfo.dialog_CreateClass_Semester.classForm.nightClass,
                    'sprintClass': this.$parentInfo.dialog_CreateClass_Semester.classForm.sprintClass,
                    'duration':this.$parentInfo.dialog_CreateClass_Semester.classForm.duration,
                    'unit_classHour':this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour,
                    'start_time':this.$parentInfo.dialog_CreateClass_Semester.classForm.start_time,
                });
            },
            get_course() {
                this.$parentInfo.dialog_CreateClass_Semester.classForm.type=1;
                this.$parentInfo.dialog_CreateClass_Semester.classForm.class_type_id = 0;
                this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price = 0;
                this.$wApi.send(this.$parentInfo.path, 'get_course', {
                    'grade_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.grade_id,
                    'subject_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.subject_id,
                    'class_type_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.class_type_id,
                    'semester_id': this.$parentInfo.modalData.semester.id,
                    'type': 'create',
                });
            },
            handleSearchClassroom(query) {
                this.$parentInfo.dialog_CreateClass_Semester.search_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'search_classroom', {
                    'classroom_name': query,
                    'template_time_semester_id': this.$parentInfo.cell.template_time_semester_id,
                    'class_id': '',
                    'class_type_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.class_type_id,
                    'semester_id': this.$parentInfo.dialog_CreateClass_Semester.classForm.semester_id
                });
            },
            classTypeChange(val, status) {
                this.$parentInfo.dialog_CreateClass_Semester.classForm.type=1
                this.$parentInfo.dialog_CreateClass_Semester.classForm.name = this.$parentInfo.grades[this.$parentInfo.dialog_CreateClass_Semester.classForm.grade_id].name +
                    this.$parentInfo.subjects[this.$parentInfo.cell.subject_id].name;
                this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price = 0;
                this.$parentInfo.dialog_CreateClass_Semester.courses.forEach((item) => {
                    if (item.class_type_id === val) {
                        this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price = item.unit_period_price;
                        if (status === 'type') {
                            this.$parentInfo.dialog_CreateClass_Semester.classForm.period = item.period
                        }
                    }
                });
                this.$parentInfo.dialog_CreateClass_Semester.classForm.name = this.$parentInfo.dialog_CreateClass_Semester.classForm.name + this.$parentInfo.class_types[val].name;
            },
            change_duration(){
                this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour=this.$parentInfo.dialog_CreateClass_Semester.classForm.duration
            },
            typeChange(){
                if(this.$parentInfo.dialog_CreateClass_Semester.classForm.type==7){
                    this.$parentInfo.dialog_CreateClass_Semester.classForm.duration=0.75
                    this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour=0.75;
                }else{
                    this.$parentInfo.dialog_CreateClass_Semester.classForm.duration=this.$parentInfo.modalData.timeData.duration;
                    this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_classHour=this.$parentInfo.modalData.timeData.duration;
                }
                if([2,3].includes(this.$parentInfo.dialog_CreateClass_Semester.classForm.type)){
                    this.$parentInfo.dialog_CreateClass_Semester.courses.forEach((item) => {
                        if (item.class_type_id ===8 && this.$parentInfo.dialog_CreateClass_Semester.classForm.type==3) {
                            this.$parentInfo.dialog_CreateClass_Semester.classForm.unit_period_price = item.unit_period_price;
                            this.$parentInfo.dialog_CreateClass_Semester.classForm.period = item.period
                        }
                    });
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .layout {
        .left {
            float: left;
            width: 500px;
        }

        .right {
            margin-left: 550px
        }
    }

    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3000;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>
